import { Component } from '@angular/core';

@Component({
    selector: 'payments-section',
    templateUrl: './section.component.html',
    styleUrls: ['./section.component.scss'],
    standalone: false
})
export class SectionComponent {}
